module.exports = __webpack_public_path__ + "img/3.f6111537.webp";